import React from 'react';

import Loading from './Loading';

import IconContainer from '../Components/IconContainer';
import { ReactComponent as TrashIcon } from '../icons/trash.svg';

export default function ButtonWithConfirmation({ entryFunc, Icon, IconSize=16, labelText, color='red', buttonName='Удалить' }) {
    const [loading, setLoading] = React.useState(false);
    const [confirmDelete, setConfirmDelete] = React.useState(false);

    const handleDeleteClick = () => {
        if (confirmDelete === false) {
            setConfirmDelete(true);
        }
        setTimeout(() => {
            setConfirmDelete(false);
        }, 2000);
    };


    return (
        <span style={{position: 'relative', display: 'inline-block'}}>
        {loading ? <div style={{margin: '0 5px'}}><Loading type='inline' /></div>
        :
            <>
                <IconContainer Icon={Icon ? Icon : TrashIcon} label={labelText} onClick={() => handleDeleteClick(true)} size ={IconSize} color={`${color}`} className = '' />
                {confirmDelete &&
                <button 
                    className={`tableButton ${color=='red' ? 'red' : ''}`}
                    style={{
                        fontSize: '12px',
                        position: 'absolute',
                        top: '50%',
                        right: 0,
                        transform: 'translateY(-50%)',
                        whiteSpace: 'nowrap',
                        zIndex: 12,
                    }}
                    onClick={() => {
                        setLoading(true);
                        entryFunc();
                        setTimeout(() => {
                            setLoading(false);
                        }, 2000);
                    }}
                >
                    {buttonName}
                </button>}
            </>
        }
        </span>
    )
}
